import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { RemoteEvent, RemoteControlKey } from './remote.model';

@Injectable()
export class RemoteControlService {

  OnKeyPress: Observable<RemoteEvent>;

  private keyPressSubject = new Subject<RemoteEvent>();

  constructor() {
    this.OnKeyPress = this.keyPressSubject.asObservable();
  }

  keyPressed(key: string, keyCode: number): void {
    const remoteKey = RemoteControlKey[keyCode];
    const remote: RemoteEvent = {
      Key: key,
      KeyCode: keyCode,
      RemoteKey: remoteKey
    };

    this.keyPressSubject.next(remote);
  }
}
